<div class="accordion">
    <div *ngFor="let panel of data" class="panel">

        <div class="panel-heading"  (click)="collapse(panel)">
            <div class="panel-title">
                <span class="accordion-icon" [ngClass]="{'icon-open': panel.collapsed,'icon-close': !panel.collapsed}"></span>
                {{panel.title}}
            </div>
        </div>

        <div *ngIf="!panel.collapsed" class="panel-collapse">
                <ng-template *ngIf="isTemplatePanel" [ngTemplateOutlet]="panelTemplate" [ngTemplateOutletContext]="{ panel: panel}">
                </ng-template>

            <!-- show normal text and/or HTML -->
            <div *ngIf="!isTemplatePanel" [innerHTML]="panel.content"></div>
        </div>
    </div>
</div>
